import Layout from 'src/layout/Layout.vue'
import PublicLayout from 'src/layout/public/PublicLayout.vue'
import VerificationHistoryLayout from 'src/layout/history/VerificationHistoryLayout.vue'
import ApplicationHistoryLayout from 'src/layout/history/ApplicationHistoryLayout.vue'
import PendingHistoryLayout from 'src/layout/history/PendingHistoryLayout.vue'
import ResolvedHistoryLayout from 'src/layout/history/ResolvedHistoryLayout.vue'
import ApplicantsHistoryLayout from 'src/layout/history/ApplicantsHistoryLayout.vue'
import CreditHistoryLayout from 'src/layout/history/CreditHistoryLayout.vue'

// Landing page

import Home from 'src/views/Home/Home.vue'

// Dashboard pages
import Overview from 'src/views/Dashboard/Overview.vue'

// Verifications
import NewVerification from 'src/views/Verifications/New.vue'
import StartVerification from 'src/views/Verifications/multi/New.vue'
import Coverage from 'src/views/Verifications/Coverage.vue'
import VerificationHistory from 'src/views/Verifications/History.vue'
import ViewVerification from 'src/views/Verifications/View.vue'
import PendingVerifications from 'src/views/Verifications/Pending.vue'
import ResolvedVerifications from 'src/views/Verifications/Resolved.vue'
import ResolveVerification from 'src/views/Verifications/Resolve.vue'
import VerificationWallet from 'src/views/Verifications/wallet/Wallet.vue'

// Applications
import StartApplication from 'src/views/Applications/Start.vue'
import ApplicationHistory from 'src/views/Applications/History.vue'
import ViewApplication from 'src/views/Applications/View.vue'
import ResultApplication from 'src/views/Applications/Result.vue'
import OpenApplications from 'src/views/Applications/Open.vue'

// Referrals
import ListReferrals from 'src/views/Referrals/List.vue'

// Credit
import BuyCredit from 'src/views/Credit/BuyCredit.vue'
import OrderTokens from 'src/views/Credit/OrderTokens.vue'
import CreditHistory from 'src/views/Credit/History.vue'
import Invoice from 'src/views/Credit/Invoice.vue'

// Account
import Account from 'src/views/Account/Account.vue'

// Analytics
import Analytics from 'src/views/Analytics/Analytics.vue'

// CountryInfo
import CountryInfo from 'src/views/CountryInfo/CountryInfo.vue'
import CountryInfoPrompt from 'src/views/CountryInfo/CountryInfoPrompt.vue'

// Maintenance
import Maintenance from "src/views/Public/Maintenance.vue";

// App properties
import properties from "src/properties";

// Public
import Login from 'src/views/Public/Login.vue'
import Password from 'src/views/Public/Password.vue'
import Unsubscribe from 'src/views/Public/Unsubscribe.vue'
import BookAMeeting from 'src/views/Public/BookAMeeting.vue'
import Register from 'src/views/Public/Register.vue'
import ViewShare from 'src/views/Public/ViewShare.vue'

import NotFound from 'src/views/Public/NotFoundPage.vue'

import Vue from 'vue'
import VueRouter from 'vue-router'
import VueScrollTo from 'vue-scrollto'
import SideBar from './components/SidebarPlugin'

import store from './store'
import EventBus from './bus'
import api from './service/api'
import moment from 'moment'

Vue.use(VueRouter)
Vue.use(VueScrollTo, {
     container: ".main-panel",
     duration: 250,
     easing: "ease",
     offset: -100,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 })
Vue.use(SideBar)

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: to => {
      var pt = store.state.paymentType
      var landing = 'home'
      if(store.state.isIndividual) {
        landing = 'wallet'
      } else if(pt != null) {
        if(pt == 'INSTITUTE' ||  pt.endsWith('_PARENT')) {
          landing = 'dashboard'
        }
      }
      return landing
      // return store.state.isIndividual ? '/wallet' : (!(pt == 'INSTITUTE' || (pt != null && pt.endsWith('_PARENT'))) ? '/home' : '/dashboard')
    },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Overview
      },
      {
        path: '/wallet',
        name: 'I\'m Verified Wallet',
        component: VerificationWallet
      },
      {
        path: 'verification/new',
        name: 'New Verification',
        component: StartVerification
      },
      {
        path: 'verification/start',
        name: 'Start Verification',
        component: NewVerification
      },
      {
        path: 'verification/coverage',
        name: 'Coverage',
        component: Coverage
      },
      {
        path: 'verification/coverage/:initRegion',
        name: 'Coverage ',
        component: Coverage,
        props: true
      },
      {
        path: 'verification/history',
        component: VerificationHistoryLayout,
        children: [
          {
            path: '',
            name: 'History',
            component: VerificationHistory
          },
          {
            path: ':id',
            name: 'View Verification',
            component: ViewVerification,
            props: true
          }
        ]
      },
      {
        path: 'application/:id/start',
        name: 'Application',
        component: StartApplication
      },
      {
        path: 'applications/open',
        component: OpenApplications
      },
      {
        path: 'referrals/list',
        name: 'Referrals',
        component: ListReferrals
      },
      {
        path: 'applicant/history',
        component: ApplicationHistoryLayout,
        children: [
          {
            path: '',
            name: 'Applicants',
            component: ApplicationHistory
          },
          {
            path: ':id',
            name: 'View Applicant',
            component: ResultApplication,
            props: true
          }
        ]
      },
      {
        path: 'verification/pending',
        component: PendingHistoryLayout,
        children: [
          {
            path: '',
            name: 'Pending Verifications',
            component: PendingVerifications
          },
          {
            path: ':id',
            name: 'Resolve Pending Verification',
            component: ResolveVerification,
            props: true
          }
        ]
      },
      {
        path: 'verification/resolved',
        component: ResolvedHistoryLayout,
        children: [
          {
            path: '',
            name: 'Resolved Verifications',
            component: ResolvedVerifications
          },
          {
            path: ':id',
            name: 'Resolved Verification',
            component: ViewVerification,
            props: (route) => ({
              id: route.params.id,
              readOnly: true
            })
          }
        ]
      },
      {
        path: 'credit/order',
        name: 'Order Credit Tokens',
        component: OrderTokens
      },
      {
        path: 'credit/buy',
        name: 'Buy Credit',
        component: BuyCredit
      },
      {
        path: 'credit/history',
        component: CreditHistoryLayout,
        children: [
          {
            path: '',
            name: 'Invoices',
            component: CreditHistory
          },
          {
            path: ':id',
            name: 'Invoice',
            component: Invoice,
            props: true
          }
        ]
      },
      {
        path: 'account',
        name: 'Account',
        component: Account
      },
      {
        path: 'faqs',
        name: 'FAQS',
        beforeEnter() {
          if (!store.state.isIndividual) {
            window.open('https://www.qualificationcheck.com/organisation-faqs', '_blank');
          } else {
            window.open('https://www.qualificationcheck.com/applicant-faqs', '_blank');
          }
        },
      },
      {
        path: 'analytics',
        name: 'Analytics',
        component: Analytics
      },
      {
        path: 'countryinfo',
        name: 'Country Insights',
        component: CountryInfo
      },
      {
        path: 'countryinfoprompt',
        // Changed name from Country Insights to Country Insight to resolve the name duplicate issue with
        // with the object name on line 260.
        name: 'Country Insight',
        component: CountryInfoPrompt
      },
    ]
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: Maintenance
  },
  {
    path: '/login',
    component: PublicLayout,
    children: [
      {
        path: '',
        name: 'Login',
        component: Login
      },
      {
        path: 'naric',
        name: 'UK NARIC Login',
        component: Login,
          props: (route) => ({
            partnerLogo: 'static/img/partners/NARIC_Logo.svg'
          })
      },
      {
        path: 'reset/:resetToken?',
        name: 'ResetPassword',
        component: Password,
        props: true
      },
      {
        path: 'register/:regToken?',
        name: 'Register',
        component: Register,
        props: true
      },
      {
        path: 'register/share/:shareinvite?',
        name: 'RegisterShare',
        component: Register,
        props: true
      }
    ]
  },
  {
    path: '/reset/:resetToken',
    redirect: '/login/reset/:resetToken'
  },
  {
    path: '/unsubscribe/:appid?',
    component: PublicLayout,
    children: [
      {
        path: '',
        name: 'Unsubscribe',
        component: Unsubscribe
      }
    ]
  },
  {
    path: '/BookAMeeting',
    component: PublicLayout,
    children: [
      {
        path: '',
        name: 'BookAMeeting',
        component: BookAMeeting
      }
    ]
  },
  {
    path: '/register/:regToken?',
    redirect: to => `/login/register/${to.params.regToken || ''}`
  },
  {
    path: '/register/share/:shareinvite?',
    redirect: '/login/register/share/:shareinvite'
  },
  {
    path: '/verify',
    component: PublicLayout,
    children: [
      {
        path: ':id',
        name: 'Verify',
        component: ResolveVerification,
        props: route => ({
          id: route.params.id,
          public: true
        })
      }
    ]
  },
  {
    path: '/view',
    component: PublicLayout,
    children: [
      {
        path: ':id',
        name: 'View Share',
        component: ViewShare,
        props: route => ({
          id: route.params.id
        })
      }
    ]
  },
  {
    path: '*',
    component: PublicLayout,
    children: [
      {
        path: '',
        name: 'Not Found',
        component: NotFound
      }
    ]
  }
]


const router = new VueRouter({
  routes, // short for routes: routes,
  // scrollBehavior (to, from, savedPosition) {
  //   return new Promise((resolve, reject) => {
  //     setTimeout(() => {
  //       resolve({ x: 0, y: 0 })
  //     }, 500)
  //   })
  // },
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
    if(properties.productDowntimeEndDate) {
      if (to.path !== '/maintenance') {
        next('/maintenance')
      } else {
        next()
      }
    } else {
      if (to.name != 'Login' && to.name != 'UK NARIC Login' && to.name != 'ResetPassword' && to.name != 'Register' && to.name != 'RegisterShare' && to.name != 'Verify' && to.name != 'View Share' && to.name != 'Unsubscribe' && to.name != 'BookAMeeting') {
        if (store.state.token == null) {
          if (to && to.path) {
            store.commit('setRedirectPage', to.path)
          }
          if (window.location.href.includes('app.qualificationcheck')
            || window.location.href.includes('debug.qualificationcheck')
            || window.location.href.includes('beta.qualificationcheck')) {
            next('/login') // Not logged in, redirect to login page
          } else {
            next('/login/register') // Not logged in, coming via an applicant lander, redirect to register page
          }
        } else {
          if (moment().isAfter(store.state.expiry)) {
            api.refreshLogin()
              .then(response => {
                next() // Token was expired, refreshed successfullly, go to requested page
                try {
                  VueScrollTo.scrollTo('#contentTop')
                } catch (error) {
                  // Just swallow it, who cares if didn't scroll up
                }
              })
              .catch(error => {
                var status = ((error || {}).response || {}).status
                if (status == 'QC-CANTREFRESH') {
                  EventBus.$emit('error', "Session expired.")
                } else if (status != 401) {
                  console.log(error)
                  EventBus.$emit('error', "An unknown error occurred trying to keep your session alive, please try again or report this error.")
                }
                store.commit('logout')
                next('/login?expired=true') // Token was expired, refresh failed, redirect to login page
              })
          } else if (to.path == '/countryinfo' && store.state.hasCountryAccess == false) { // If user goes direct to country insights URL but has no access should redirect
            next('/countryinfoprompt')
          } else if (to.path == '/countryinfoprompt' && store.state.hasCountryAccess) { // If user goes direct to the country insights no access page, but has access, should redirect to correct page
            next('/countryinfo')
          } else if (to.name == 'Dashboard' && (store.state.paymentType == 'INSTITUTE' || store.state.paymentType.endsWith('_PARENT')) && store.getters.allowedTypes.length < 1) {
            next('/verification/pending')
          } else if (to.path == '/analytics' && store.state.hasAnalyticsAccess == false || to.path == '/analytics' && store.state.admin == false) { // If user goes direct to analytics URL but has no access should redirect
            next('/')
          } else {
            next() // Token was not expired, go to requested page
            try {
              VueScrollTo.scrollTo('#contentTop')
            } catch (error) {
              // Just swallow it, who cares if didn't scroll up
            }
          }
        }
      } else {
        next()
      }
    }
})

export default router
